import { useContext, useState } from "react";
import info from "../assets/info.svg";
import CustomDropdown from "./CustomDropdown";
import Head from "./Head";
import Footer from "../components/Footer";
import RenderSvg from "../components/RenderSvg";
import GlobalConfig from "../context/GlobalConfig";
import { languageData } from "../constants/languageData";

function HelpFaq({ stepperFunc, stepHistory, steps, currentStep }) {
  const { config } = useContext(GlobalConfig);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const language = sessionStorage.getItem("language") ?? "en";
  const color = config?.branding?.accentColor;

  // Fetch language-specific text from languageData
  const currentLanguage = language || "en";
  const permissionText =
    languageData[currentLanguage]?.helpFaq?.cameraText ||
    "To verify your identity, we need to capture images using your device's camera. Follow this link to learn how to grant the required permissions.";
  const languageText =
    languageData[currentLanguage]?.helpFaq?.languageText ||
    "At the beginning of the process, you can choose your preferred language by selecting it from the dropdown menu in the top bar.";
  const kycText =
    languageData[currentLanguage]?.helpFaq?.kycText ||
    "KYC, or Know Your Customer, is a process to verify customer identities, ensuring compliance and preventing fraud and other illegal activities.";
  const timeText =
    languageData[currentLanguage]?.helpFaq?.timeText ||
    "Usually, it takes around 60 seconds. However, this can vary depending on the countries.";

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const handleLinkClick = () => {
    const userAgent = navigator.userAgent;
    let supportUrl;
  
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg/")) {
      // This ensures it's Chrome, not Edge
      supportUrl = "https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop&oco=0";
    } else if (userAgent.includes("Edg/")) {
      // Edge specifically
      supportUrl = "https://help.doxy.me/en/articles/3867526-camera-and-microphone-permission-edge";
    } else if (userAgent.includes("Firefox")) {
      supportUrl = "https://help.doxy.me/en/articles/2427185-camera-and-microphone-permission-firefox";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      supportUrl = "https://help.doxy.me/en/articles/836274-camera-and-microphone-permission-safari";
    } else {
      // Default Chrome link
      supportUrl = "https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop&oco=0";
    }
  
    window.open(supportUrl, "_blank");
  };

  return (
    <>
      <Head
        showBackIcon
        style={{ zIndex: "100" }}
        stepperFunc={stepperFunc}
        handleBack={() => stepperFunc(stepHistory[stepHistory.length - 1])}
      />
      <div className="parent-container">
        <div className="main">
          <div className="left-section">
            <RenderSvg config={config} id={"faq"} svgType={"faq"} />
          </div>
          <div
            className="right-section md:items-start items-center"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 24,
              fontFamily: "Inter, sans-serif",
              
            }}
          >
            <div
              className="flex flex-col md:mb-[32px] mb-[18px]"
              style={{
                gap: "16px",
                alignSelf: "stretch",
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
              }}
            >
              <div
                className="text-[18px] md:text-[24px] text-center md:text-left"
                style={{
                  color: "#000",
                }}
              >
                {languageData[currentLanguage]?.helpFaq?.title || "Help & FAQs"}
              </div>
              <div
                className="text-[14px] font-semibold text-center md:text-left"
                style={{
                  color: "#656565",
                }}
              >
                {languageData[currentLanguage]?.helpFaq?.subtitle ||
                  "We are here to help you"}
              </div>
            </div>
            <div
              className="max-h-[220px] md:max-h-[325px] md:pr-[8px] overflow-y-auto"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                // Fill the available space in the card and scroll if needed, so the
                // FAQ list is not clipped by a fixed height for longer (non-English)
                // translations — language-independent dynamic height.
                flex: "1 1 auto",
                minHeight: 0,
              }}
            >
              <CustomDropdown
                heading={languageData[currentLanguage]?.helpFaq?.cameraHeading || "Camera permission"}
                color={color}
                isOpen={openDropdownIndex === 0}
                toggleDropdown={() => toggleDropdown(0)}
                text={permissionText}
                svgType={"camera"}
                onLinkClick={handleLinkClick}
              />
              <CustomDropdown
                heading={languageData[currentLanguage]?.helpFaq?.languageHeading || "Language Selection"}
                isOpen={openDropdownIndex === 1}
                color={color}
                toggleDropdown={() => toggleDropdown(1)}
                text={languageText}
                svgType={"language"}
              />
              <CustomDropdown
                heading={languageData[currentLanguage]?.helpFaq?.kycHeading || "What is KYC?"}
                isOpen={openDropdownIndex === 2}
                color={color}
                toggleDropdown={() => toggleDropdown(2)}
                text={kycText}
                svgType={"kyc"}
              />
              <CustomDropdown
                heading={languageData[currentLanguage]?.helpFaq?.timeHeading || "How much time will it take?"}
                isOpen={openDropdownIndex === 3}
                color={color}
                toggleDropdown={() => toggleDropdown(3)}
                text={timeText}
                svgType={"timer"}
              />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default HelpFaq;
